export default __webpack_public_path__ + "static/media/staff-id-card-2.caf26cf0.jpg";